export default () => `
    id
    email
    name
    phone
    roles {
        org
        fein
        role
        primaryContact
        alternativeContact
    }
    orgs
`;
